import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourcesStepsOneLoadingWrapper = styled.div`
  width: 100%;

  min-height: 522px;
  max-width: 1440px;

  display: flex;
  flex-direction: column;
  align-self: center;

  position: relative;
`;

export const ResourcesStepsOneLoadingContainer = styled(motion.div).attrs({
  variants: {
    start: {
      opacity: 1,
    },
    finish: {
      top: 0,
      bottom: -500,
    },
  },
  exit: {
    opacity: 0,
  },
})`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;

  padding: 25px 46px;

  border-radius: 8px;
  background: rgba(255, 255, 255, 0.6);

  ${BREAKPOINTS.tablet} {
    padding: 20px 16px;
    top: 134px;
  }
`;

export const ResourcesStepsOneLoadingTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ResourcesStepsOneLoadingTitle = styled.h3`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  ${BREAKPOINTS.tablet} {
    font-size: 18px;
  }

  color: var(--color-text);
`;

export const ResourcesStepsOneLoadingGif = styled(motion.img).attrs({
  src: '/images/people/loading.gif',
  exit: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
})`
  width: 132px;
  height: 132px;
`;

export const ResourcesStepsOneLoadingCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  ${BREAKPOINTS.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${BREAKPOINTS.mobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
